import DataService from './DataService';

export default DataService;


// WEBPACK FOOTER //
// ./src/Services/Data/index.tsx